import styled from 'styled-components';

import { TrackedLink } from 'components/Link';

export const FlashLink = styled(TrackedLink)`
  font-weight: inherit;
`;
